import { createContext } from 'react';

export interface AppUpdateContextValue {
  hasNewVersion: boolean;
  applyUpdateNow: () => Promise<void>;
  /** 从 TopBar 再次打开更新说明弹窗（与首次发现新版本时一致） */
  requestUpdateDialog: () => void;
  remoteVersion: string | null;
  forceHardRefresh: boolean;
  /** 代码已是最新，仅剩强制更新要求的本地缓存清理未完成 */
  cleanupOnly: boolean;
  /** 本次发布的更新内容列表 */
  changelog: string[];
}

export const AppUpdateContext = createContext<AppUpdateContextValue | null>(null);
